export const getDateSeperator = (format: string): string => {
    return format.includes("/")
        ? "/"
        : format.includes("-")
          ? "-"
          : format.includes(".")
            ? "."
            : " ";
};

const defaultDateFormats = "YYYY-MM-DD";

/*TODO INTL - when we get to non western countries that are non English this formatting
stuff will of course not be adequate, however that is probably a signficant ways away and this should work
until then*/
const determinePartsOfDate = (format: string) => {
    const seperator = getDateSeperator(format);
    const formatArray = format.split(seperator);
    const yearIndex = formatArray.findIndex((item) => item.includes("YYYY"));
    const monthIndex = formatArray.findIndex((item) => item.includes("MM"));
    const dayIndex = formatArray.findIndex((item) => item.includes("DD"));
    return { yearIndex, monthIndex, dayIndex };
};
export const structureDate = (format: string, date: string) => {
    const { yearIndex, monthIndex, dayIndex } = determinePartsOfDate(format);
    const seperator = getDateSeperator(format);
    const dateArray = date?.split(seperator);
    return [dateArray[yearIndex], dateArray[monthIndex], dateArray[dayIndex]];
};
export const dateHandlers = {
    dateFieldsLayout: (format: string) => {
        const { yearIndex, monthIndex, dayIndex } = determinePartsOfDate(format);
        const arr = [];
        arr[yearIndex] = "Year";
        arr[monthIndex] = "Month";
        arr[dayIndex] = "Day";
        return arr;
    },
    defaultConvertFromCTFormat: (format: string, date: string) => {
        const dateArray = structureDate(defaultDateFormats, date);
        const year = dateArray[0];
        const month = dateArray[1];
        const day = dateArray[2];
        const { yearIndex, monthIndex, dayIndex } = determinePartsOfDate(format);
        const seperator = getDateSeperator(format);
        dateArray[yearIndex] = year;
        dateArray[monthIndex] = month;
        dateArray[dayIndex] = day;
        return dateArray.join(seperator);
    },
};

// This function takes a date string returned by react-datepicker library and converts it to a format that can be used by the backend
export const formatDateForDatePicker = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

const dateFormats = {
    "ja-JP": "YYYY年MM月dd日",
};

export const getDateFormat = (locale: string) => {
    return dateFormats[locale] || defaultDateFormats;
};

export const formatDateForLocale = (date: string, locale: string) => {
    const format = getDateFormat(locale);
    if (format === defaultDateFormats) {
        return date;
    }
    const [year, month, day] = date.split("-");
    return format.replace("YYYY", year).replace("MM", month).replace("dd", day);
};
